<div class=" m-t-space m-space m-t-3">
  <div>
    <div class="mt-2 ml-2 mr-2 frame-container">
      <div class="text-center frame-background-custom f-10x col-auto">
        <span>QR PAYMENT</span>
      </div>
      <div class="col-auto p-3">
        <div class=" mt-3 p-7 col-auto frame-picture"
             [style.backgroundImage]="'url(' + imgQrcode + ')'"
             style="background-size: cover;background-position: center;">
        </div>
      </div>
      <div class="pb-2">
        <div class="pt-1 text-center m-t-3">
<!--          <span class="font-weight-bold f-10x">{{sellerName}}</span>-->
          <span class="f-10x">จำนวนเงินที่ต้องชำระ</span>
          <br>
          <span class="f-10x">{{totalAmount | number:'1.2-2'}} บาท (BAHT)</span>
        </div>
        <div class="mt-3 text-center frame-background-custom" style="height: 20px"></div>
        <div class="text-center mt-1">
          <span class="f-7x">หากชำระเงินเรียบร้อย สามารถปิดหน้าต่างนี้ได้เลย</span>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/qr-code/qr-code.component.html